module.exports = __webpack_public_path__ + "img/chat_b.60ac7378.png";